import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MyAccountSettings.scss";
import DetailTabDisableIcon from "../../common/images/detail-disabled-icon.svg";
import DetailTabEnableIcon from "../../common/images/detail-enabled-icon.svg";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import bcrypt from "bcryptjs";
import cookie from "react-cookies";
import axios from "axios";
import { apiUrl } from "../Helpers/Config";
import AlertPopup from "../../common/components/AlertPopup/AlertPopup";
import ModalPopup from "../../common/components/ModalPopup/ModalPopup";
import { showLoader } from "../Helpers/SettingHelper";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { handleApiCall } from "../Helpers/apiHelper";
import ChangePasswordTabDisabledIcon from "../../common/images/my-acc-changepassword-tab-disabled-icon.svg";
import ChangePasswordTabEnabledicon from "../../common/images/my-acc-changepassword-tab-enabled-icon.svg";
import AccDeactiveTabDisabledIcon from "../../common/images/my-acc-cancellation-tab-disabled-icon.svg";
import AccDeactiveTabEnabledIcon from "../../common/images/my-acc-cancellation-tab-enabled-icon.svg";
let base64 = require("base-64");

const MyAccountSettings = (props) => {
  const { customerDetails, buttonLoader } = props;
  const [activeTab, setActiveTab] = useState("change-password");
  const [fields, setFields] = useState({
    selectedReason: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    isAgreedForChangePassword: false,
    isAgreedForDeactivation: false,
    error_selectedReason: false,
    error_currentPassword: false,
    error_currentPassword_msg: "",
    error_newPassword: false,
    error_newPassword_msg: "",
    error_confirmPassword: false,
    error_confirmPassword_msg: "",
    current_password_matched: false,
    error_isAgreedForChangePassword: false,
    error_isAgreedForDeactivation: false,
  });
  const [passwordType, setPasswordType] = useState({
    currentPassword: "password",
    newPassword: "password",
    confirmPassword: "password",
    deactivationPassword: "password",
  });
  const [alertPopup, setAlertPopup] = useState({
    open: false,
    title: "",
    message: "",
  });
  const [openDeactivatePopup, setOpenDeactivePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const deactivationReasons = [
    "I have another Fizota account",
    "I have concerns with Fizota's policy",
    "I have better alternative platform",
    "The platform is complicated to use",
    "Fizota's support is not great.",
  ];

  const handleChangeFields = (event) => {
    const { name, value, checked } = event.target;
    let updatedFields;
    if (
      name === "isAgreedForChangePassword" ||
      name === "isAgreedForDeactivation"
    ) {
      updatedFields = { ...fields, [name]: checked };
    } else {
      updatedFields = { ...fields, [name]: value };
    }

    if (name === "selectedReason") {
      if (value === "") {
        updatedFields.error_selectedReason = true;
      } else {
        updatedFields.error_selectedReason = false;
      }
    }

    if (name === "currentPassword") {
      updatedFields.error_currentPassword = false;
      updatedFields.error_currentPassword_msg = "";
      updatedFields.current_password_matched = fields.current_password_matched;
      if (value.trim() === "") {
        updatedFields.error_currentPassword = true;
        updatedFields.error_currentPassword_msg = "This field is required";
        updatedFields.current_password_matched = false;
      } else {
        const storedHash = customerDetails.customer_password;
        const isPasswordCorrect = bcrypt.compareSync(value, storedHash);
        if (!isPasswordCorrect) {
          updatedFields.error_currentPassword = true;
          updatedFields.error_currentPassword_msg =
            "Current password is not correct";
          updatedFields.current_password_matched = false;
        } else {
          updatedFields.error_currentPassword = false;
          updatedFields.current_password_matched = true;
        }
      }
    }

    if (name === "newPassword") {
      updatedFields.error_newPassword = false;
      updatedFields.error_newPassword_msg = "";
      if (value.trim() === "") {
        updatedFields.error_newPassword = true;
        updatedFields.error_newPassword_msg = "This field is required";
      } else {
        const storedHash = customerDetails.customer_password;
        const isOldPassword = bcrypt.compareSync(value, storedHash);
        if (isOldPassword) {
          updatedFields.error_newPassword = true;
          updatedFields.error_newPassword_msg =
            "This is your current password. Please enter different one";
        } else {
          if (fields.newPassword.length < 8) {
            updatedFields.error_newPassword = true;
            updatedFields.error_newPassword_msg =
              "Password should be at least 8 characters";
          }
        }
      }
    }

    if (name === "confirmPassword") {
      updatedFields.error_confirmPassword = false;
      updatedFields.error_confirmPassword_msg = "";
      if (value.trim() === "") {
        updatedFields.error_confirmPassword = true;
        updatedFields.error_confirmPassword_msg = "This field is required";
      } else if (value !== fields.newPassword) {
        updatedFields.error_confirmPassword = true;
        updatedFields.error_confirmPassword_msg = "Passwords do not match";
      }
    }

    if (name === "isAgreedForChangePassword") {
      updatedFields.error_isAgreedForChangePassword = false;
      if (checked === false) {
        updatedFields.error_isAgreedForChangePassword = true;
      }
    }

    if (name === "isAgreedForDeactivation") {
      updatedFields.error_isAgreedForDeactivation = false;
      if (checked === false) {
        updatedFields.error_isAgreedForDeactivation = true;
      }
    }

    if (name === "deactivationPassword") {
      updatedFields.error_deactivationPassword = false;
      updatedFields.error_deactivationPassword_msg = "";
      updatedFields.current_password_matched = fields.current_password_matched;
      if (value.trim() === "") {
        updatedFields.error_deactivationPassword = true;
        updatedFields.error_deactivationPassword_msg = "This field is required";
        updatedFields.current_password_matched = false;
      } else {
        const storedHash = customerDetails.customer_password;
        const isPasswordCorrect = bcrypt.compareSync(value, storedHash);
        if (!isPasswordCorrect) {
          updatedFields.error_deactivationPassword = true;
          updatedFields.error_deactivationPassword_msg =
            "Current password is not correct";
          updatedFields.current_password_matched = false;
        } else {
          updatedFields.error_deactivationPassword = false;
          updatedFields.current_password_matched = true;
        }
      }
    }

    setFields(updatedFields);
  };

  const handleUpdatePassword = () => {
    let error = 0;

    // Reset previous errors first
    setFields((prev) => ({
      ...prev,
      error_isAgreedForChangePassword: false,
      error_currentPassword: false,
      error_currentPassword_msg: "",
      error_newPassword: false,
      error_newPassword_msg: "",
      error_confirmPassword: false,
      error_confirmPassword_msg: "",
    }));

    // Check if user agreed to change password
    if (!fields.isAgreedForChangePassword) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_isAgreedForChangePassword: true,
      }));
    }

    // Check if current password is filled
    if (!fields.currentPassword?.trim()) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_currentPassword: true,
        error_currentPassword_msg: "Current password is required",
      }));
    } else if (!fields.current_password_matched) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_currentPassword: true,
        error_currentPassword_msg: "Password is not correct",
      }));
    }

    // Check if new password and confirm password are filled
    const storedHash = customerDetails.customer_password;
    const isOldPassword = bcrypt.compareSync(fields.newPassword, storedHash);
    if (!fields.newPassword?.trim()) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_newPassword: true,
        error_newPassword_msg: "New password is required",
      }));
    } else if (isOldPassword) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_newPassword: true,
        error_newPassword_msg:
          "This is your current password. Please enter different one",
      }));
    } else {
      if (fields.newPassword.length < 8) {
        setFields((prev) => ({
          ...prev,
          error_newPassword: true,
          error_newPassword_msg: "Password should be at least 8 characters",
        }));
      }
    }
    if (!fields.confirmPassword?.trim()) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_confirmPassword: true,
        error_confirmPassword_msg: "Confirm password is required",
      }));
    } else if (fields.newPassword !== fields.confirmPassword) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_confirmPassword: true,
        error_confirmPassword_msg: "Passwords do not match",
      }));
    } else {
      // Check password lengths
      if (fields.newPassword.length < 8) {
        error++;
        setFields((prev) => ({
          ...prev,
          error_newPassword: true,
          error_newPassword_msg: "Password should be at least 8 characters",
        }));
      }

      if (fields.confirmPassword.length < 8) {
        error++;
        setFields((prev) => ({
          ...prev,
          error_confirmPassword: true,
          error_confirmPassword_msg: "Password should be at least 8 characters",
        }));
      }
    }

    if (error === 0) {
      setIsLoading(true);
      // Proceed with API call
      const formData = new FormData();
      formData.append("refrence", base64.encode(cookie.load("UserId")));
      formData.append("oldpassword", base64.encode(fields.currentPassword));
      formData.append("password", base64.encode(fields.newPassword));
      formData.append("confirmpassword", base64.encode(fields.confirmPassword));

      axios
        .post(apiUrl + "customer/changepassword", formData, {
          headers: {
            Authorization: cookie.load("acccesstoken"),
          },
        })
        .then((res) => {
          if (res.data.status === "ok") {
            handleShowAlertPopup("Success", res.data.message);
            setFields((prev) => ({
              ...prev,
              currentPassword: "",
              newPassword: "",
              confirmPassword: "",
              isAgreedForChangePassword: false,
            }));
            setPasswordType({
              currentPassword: "password",
              newPassword: "password",
              confirmPassword: "password",
            });
            const params = "customer_id=" + cookie.load("UserId");
            props.handleGetCustomerDetails(params);
          } else {
            handleShowAlertPopup("Alert", res.data.message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error changing password:", error);
          handleShowAlertPopup(
            "Error",
            "Something went wrong. Please try again."
          );
        });
    }
  };

  const handleShowAlertPopup = (title, msg, callBack) => {
    setAlertPopup({
      open: true,
      title: title,
      message: msg,
    });
    if (callBack === "logout") {
      setTimeout(() => {
        cookie.remove("UserId", { path: "/logout" });
        window.location.href = "/logout";
      }, 2000);
    }
  };

  const handleOpenDeactivatePopup = () => {
    let errorCount = 0;
    const newErrors = {};

    if (!fields.selectedReason) {
      newErrors.error_selectedReason = true;
      errorCount++;
    }

    if (!fields.isAgreedForDeactivation) {
      newErrors.error_isAgreedForDeactivation = true;
      errorCount++;
    }

    if (errorCount > 0) {
      setFields((prev) => ({
        ...prev,
        ...newErrors,
      }));
      return null;
    }

    setOpenDeactivePopup(true);
  };

  const handleDeactivateAccount = async () => {
    const password = fields.deactivationPassword?.trim();
    let error = 0;

    setFields((prev) => ({
      ...prev,
      error_deactivationPassword: false,
      error_deactivationPassword_msg: "",
    }));

    if (!password) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_deactivationPassword: true,
        error_deactivationPassword_msg: "Current password is required",
      }));
    } else if (!fields.current_password_matched) {
      error++;
      setFields((prev) => ({
        ...prev,
        error_deactivationPassword: true,
        error_deactivationPassword_msg: "Password is not correct",
      }));
    }
    if (error === 0) {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("customer_id", base64.encode(cookie.load("UserId")));
      formData.append("customer_status", "D");
      formData.append("deactivate_reason", fields.selectedReason);
      const res = await handleApiCall(
        "post",
        "customer/deactivation",
        formData
      );
      if (res.data.status === "ok") {
        handleShowAlertPopup("Success", res.data.message, "logout");
        setFields({
          selectedReason: "",
          currentPassword: "",
          isAgreedForDeactivation: false,
          error_selectedReason: false,
          error_currentPassword: false,
          error_currentPassword_msg: "",
          current_password_matched: false,
          error_isAgreedForDeactivation: false,
        });
      } else {
        handleShowAlertPopup("Alert", "Something went wrong");
      }
      setOpenDeactivePopup(false);
      setIsLoading(false);
    }
  };

  const handleSetPasswordType = (field) => {
    setPasswordType((prev) => ({
      ...prev,
      [field]: prev[field] === "text" ? "password" : "text",
    }));
  };

  const handleChangeTab = (value) => {
    setActiveTab(value);
    setFields({
      selectedReason: "",
      currentPassword: "",
      isAgreedForDeactivation: false,
      error_selectedReason: false,
      error_currentPassword: false,
      error_currentPassword_msg: "",
      current_password_matched: false,
      error_isAgreedForDeactivation: false,
    });
  };

  return (
    <>
      <div className="settings-sec-cntnr">
        <div className="settings-sec-cntnr__tab-row">
          <div
            className={`settings-sec-cntnr__tab-row__col ${
              activeTab === "change-password" ? "col-active" : ""
            }`}
            onClick={() => handleChangeTab("change-password")}
          >
            <img
              src={
                activeTab === "change-password"
                  ? ChangePasswordTabEnabledicon
                  : ChangePasswordTabDisabledIcon
              }
              alt="documentIcon"
            />
            <span>Change password</span>
          </div>
          <div
            className={`settings-sec-cntnr__tab-row__col ${
              activeTab === "account-deactive" ? "col-active" : ""
            }`}
            onClick={() => handleChangeTab("account-deactive")}
          >
            <img
              src={
                activeTab === "account-deactive"
                  ? AccDeactiveTabEnabledIcon
                  : AccDeactiveTabDisabledIcon
              }
              alt="documentIcon"
            />
            <span>Account deactivation</span>
          </div>
        </div>
        <div className="settings-sec-cntnr__edit-row">
          {activeTab === "change-password" && (
            <div className="settings-sec-cntnr__edit-row__col">
              <h3>Change Your password</h3>
              <label for="currentPassword">Enter current password</label>
              <div className="pwd-input-cntnr">
                <input
                  type={passwordType.currentPassword}
                  id="currentPassword"
                  name="currentPassword"
                  value={fields.currentPassword}
                  onChange={handleChangeFields}
                  className={
                    fields.error_currentPassword_msg ? "input-have-err" : ""
                  }
                />
                <div
                  className="pwd-visible-btn"
                  onClick={() => handleSetPasswordType("currentPassword")}
                >
                  {passwordType.currentPassword === "password" ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </div>
              </div>
              {fields.error_currentPassword && (
                <div className="err-text">
                  <p>{fields.error_currentPassword_msg}</p>
                </div>
              )}
              <label for="newPassword">Enter new password</label>{" "}
              <div className="pwd-input-cntnr">
                <input
                  type={passwordType.newPassword}
                  id="newPassword"
                  name="newPassword"
                  value={fields.newPassword}
                  onChange={handleChangeFields}
                  className={fields.error_newPassword ? "input-have-err" : ""}
                />
                <div
                  className="pwd-visible-btn"
                  onClick={() => handleSetPasswordType("newPassword")}
                >
                  {passwordType.newPassword === "password" ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </div>
              </div>
              {fields.error_newPassword && (
                <div className="err-text">
                  <p>{fields.error_newPassword_msg}</p>
                </div>
              )}
              <label for="confirmPassword">Re enter new password</label>
              <div className="pwd-input-cntnr">
                <input
                  type={passwordType.confirmPassword}
                  id="confirmPassword"
                  name="confirmPassword"
                  value={fields.confirmPassword}
                  onChange={handleChangeFields}
                  className={
                    fields.error_confirmPassword_msg ? "input-have-err" : ""
                  }
                  disabled={fields.newPassword === ""}
                />
                <div
                  className="pwd-visible-btn"
                  onClick={() => handleSetPasswordType("confirmPassword")}
                >
                  {passwordType.confirmPassword === "password" ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </div>
              </div>
              {fields.error_confirmPassword && (
                <div className="err-text">
                  <p>{fields.error_confirmPassword_msg}</p>
                </div>
              )}
              <div
                className={`consent-checkbox ${
                  fields.error_isAgreedForChangePassword
                    ? "checkbox-have-err"
                    : ""
                }`}
              >
                <input
                  type="checkbox"
                  id="isAgreedForChangePassword"
                  name="isAgreedForChangePassword"
                  checked={fields.isAgreedForChangePassword}
                  onChange={handleChangeFields}
                />
                <label for="isAgreedForChangePassword">
                  By resetting your account password you agree to our{" "}
                  <Link
                    to="/terms-and-conditions"
                    target="_blank"
                    className="link"
                  >
                    Terms & Conditions
                  </Link>{" "}
                  and{" "}
                  <Link to="/privacy-policy" target="_blank" className="link">
                    Privacy Policy
                  </Link>
                  .
                </label>
              </div>
              {fields.error_isAgreedForChangePassword && (
                <div className="err-text">
                  <p>
                    Please agree to the Terms & Conditions and Privacy Policy
                  </p>
                </div>
              )}
              <button
                className="settings-btn settings-btn--primary"
                onClick={handleUpdatePassword}
              >
                {isLoading && buttonLoader()}Change password
              </button>
            </div>
          )}
          {activeTab === "account-deactive" && (
            <div className="settings-sec-cntnr__edit-row__col">
              <h3>Account deactivation</h3>
              <h2>What happens when you deactivate your account?</h2>
              <ul>
                <li>
                  Your saved details will be deleted. Your booking &
                  cancellation and Wishlist details will not be accessible.
                </li>
                <li>
                  You will not be able to create packages and receive commission
                  anymore.
                </li>
                <li>
                  You will not be able to re-activate the same account again.
                </li>
              </ul>
              <label for="selectedReason">
                I want deactivate my account because
              </label>
              <Select
                id="selectedReason"
                name="selectedReason"
                value={fields.selectedReason}
                onChange={handleChangeFields}
                className={`deact-select-input ${
                  fields.error_selectedReason ? "input-have-err" : ""
                }`}
                displayEmpty
                renderValue={(selected) =>
                  selected ? (
                    selected
                  ) : (
                    <span style={{ color: "#aaa" }}>Select a reason</span>
                  )
                }
              >
                <MenuItem value="" disabled>
                  Select a reason
                </MenuItem>
                {deactivationReasons.map((reason, index) => (
                  <MenuItem key={index} value={reason}>
                    {reason}
                  </MenuItem>
                ))}
              </Select>
              {fields.error_selectedReason && (
                <div className="err-text">
                  <p>Please select a reason</p>
                </div>
              )}
              <div
                className={`consent-checkbox ${
                  fields.error_isAgreedForDeactivation
                    ? "checkbox-have-err"
                    : ""
                }`}
              >
                <input
                  type="checkbox"
                  id="isAgreedForDeactivation"
                  name="isAgreedForDeactivation"
                  checked={fields.isAgreedForDeactivation}
                  onChange={handleChangeFields}
                />
                <label for="isAgreedForDeactivation">
                  By deleting account you agree to our{" "}
                  <Link
                    to="/terms-and-conditions"
                    target="_blank"
                    className="link"
                  >
                    Terms & Conditions
                  </Link>{" "}
                  and{" "}
                  <Link to="/privacy-policy" target="_blank" className="link">
                    Privacy Policy
                  </Link>
                  .
                </label>
              </div>
              {fields.error_isAgreedForDeactivation && (
                <div className="err-text">
                  <p>
                    Please agree to the Terms & Conditions and Privacy Policy
                  </p>
                </div>
              )}
              <button
                className="settings-btn settings-btn--warning"
                onClick={handleOpenDeactivatePopup}
              >
                Deactivate account
              </button>
            </div>
          )}
        </div>
      </div>
      <ModalPopup
        open={openDeactivatePopup}
        handleClose={() => setOpenDeactivePopup(false)}
        className="common-popup textcenter"
      >
        <div className="deactivate-popup-main">
          <h4>To confirm deactivation, enter your account password below!</h4>
          <label className="deactivationPassword">Enter Current password</label>
          <input
            type={passwordType.deactivationPassword}
            name="deactivationPassword"
            value={fields.deactivationPassword}
            placeholder="Enter your current password"
            onChange={handleChangeFields}
            className={`deact-select-input ${
              fields.error_deactivationPassword ? "input-have-err" : ""
            }`}
          />
          {fields.error_deactivationPassword && (
            <div className="err-text">
              <p>{fields.error_deactivationPassword_msg}</p>
            </div>
          )}
          <button
            className="settings-btn settings-btn--primary "
            id="processDeactivate"
            onClick={handleDeactivateAccount}
          >
            {isLoading && buttonLoader()}Deactivate
          </button>
          <span>
            By clicking "Deactivate" you agree, that you have understood the
            consequences of changing your creator profile details as it may
            affect your package performances, commissions and payouts.
          </span>
        </div>
      </ModalPopup>
      <AlertPopup
        open={alertPopup.open}
        handleClose={() => setAlertPopup({ open: false })}
        title={alertPopup.title}
        message={alertPopup.message}
      />
    </>
  );
};

export default MyAccountSettings;
